import { accessTokenStore } from '@/shared/api/accessTokenStore'
import { createAuthenticatedTransport, fetchTransport } from '@/shared/api/apiTransport'
import { extractAccessToken } from '@/shared/api/extractAccessToken'
import {
  ResponseError,
  client as defaultClient,
  createClient,
} from '@/shared/api/generated/.kubb/client'
import { authRefresh } from '@/shared/api/generated/clients/authRefresh'
import { environment } from '@/shared/config/environment'

export const publicApiClient = createClient({
  baseURL: environment.apiBaseUrl,
  credentials: 'include',
  auth: undefined,
  transport: fetchTransport,
})

let refreshPromise: Promise<unknown> | undefined

export const refreshAccessToken = async () => {
  refreshPromise ??= authRefresh({ client: publicApiClient })
    .then(({ data }) => {
      const token = extractAccessToken(data)
      if (!token) {
        throw new Error('Refresh response did not contain an access token')
      }
      accessTokenStore.set(token)
      return data
    })
    .catch((error: unknown) => {
      if (error instanceof ResponseError && error.status === 401) {
        accessTokenStore.clear()
      }
      throw error
    })
    .finally(() => {
      refreshPromise = undefined
    })

  return refreshPromise
}

defaultClient.setConfig({
  baseURL: environment.apiBaseUrl,
  credentials: 'include',
  auth: () => accessTokenStore.get(),
  transport: createAuthenticatedTransport({
    transport: fetchTransport,
    refreshAccessToken,
    getAccessToken: accessTokenStore.get,
  }),
})

export const authenticatedApiClient = defaultClient
